<template>
  <modal-lightbox v-if="mobileBrowser && $store.state.showAddToHomeScreen" @close="close">
    <div class="center">
      <p>
        Add to Home Screen
      </p>
      <p class="subtext">
        Install this application on your home screen for quick and easy access.
      </p>
      <div class="spacer"></div>
      <div v-if="mobileBrowser === 'Safari'">
        <p class="subtext">
          1) Tap the share button
        </p>
        <img src="@/assets/images/ios_safari_share.png" />
        <p class="subtext">
          2) Then select "Add to Home Screen"
        </p>
        <img src="@/assets/images/ios_safari_add_to_home.png" />
        <div class="button-wrapper">
          <div v-on:click="close" class="btn btn-outline btn-rounded caps mx-auto">
            OK
          </div>
        </div>
      </div>
      <div v-else>
        <p class="subtext">
          1) Tap the menu button
        </p>
        <img src="@/assets/images/mobile_chrome_bar.png" />
        <p class="subtext">
          2) Tap "Add to Home Screen"
        </p>
        <div class="spacer"></div>
        <div class="button-wrapper">
          <div v-on:click="close" class="btn btn-outline btn-rounded caps mx-auto">
            OK
          </div>
        </div>
      </div>
    </div>
  </modal-lightbox>
</template>

<script>
  import MobileDetect from 'mobile-detect'

  export default {
    name: 'ModalAddToHomeScreen',
    data () {
      return {
        mobileBrowser: null
      }
    },
    mounted () {
      const md = new MobileDetect(window.navigator.userAgent)
      if (md.mobile()) {
        const ua = md.userAgent()
        if (ua === 'Safari' || ua === 'Chrome') {
          this.mobileBrowser = ua
        }
      }
    },
    methods: {
      close () {
        this.$store.commit('SET_SHOW_ADD_TO_HOMESCREEN', false)
      }
    }
  }
</script>

<style scoped>
.spacer {
  height: 30px;
}

.button-wrapper {
  margin-top: 1em;
}
</style>